import { useSelector } from "react-redux";
import { Box, Typography, CircularProgress } from "@mui/material";
import RecipeGrid from "./RecipeGrid";

const RecipeResults = () => {
  const {
    loading,
    filteredRecipes: recipes,
    error,
  } = useSelector((state) => state.searchResults);

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
        <CircularProgress color="primary" size={54} />
      </Box>
    );
  if (error)
    return (
      <Typography
        color="error"
        sx={{
          textAlign: "center",
          mt: 4,
          fontWeight: 700,
          bgcolor: "rgba(255,255,255,0.75)",
          borderRadius: 4,
          px: 2,
          py: 1.5,
        }}
      >
        {error}
      </Typography>
    );
  if (!recipes || recipes.length === 0) return null;

  return <RecipeGrid recipes={recipes} />;
};

export default RecipeResults;
